module.exports = __webpack_public_path__ + "static/hymotsg1-34a6d69fa9d05ee85e4d274c2415c310.png";